<template>
  <div class="initiativer">
    <h1 style="font-weight:700;">研究經費獎補助機構可以如何提倡開放取用</h1>
    <h3 style="font-weight:500;">在研究經費獎補助合約上加上開放取用的條件。若是接受獎補助，則代表受補助之作者同意提供所有在獎補助經費下產出之研究文獻的開放取用。</h3>

    <ul class="txt1" style="text-indent : -1em ;">
      <li>
        ● 此條款碰上特殊狀況時也會有例外，如機密的軍事研究、可申請專利的發明，以及預期帶來收益的研究。
      </li>
  <p style="line-height:2;"></p>
      <li>● 此條款應給予受補助的作者選擇開放取用的提供方式。作者可選擇開放取用期刊或開放取用典藏庫。當作者選擇開放取用典藏庫時，應能將成果上傳至任何符合特定取用條件、互通性和長期保存特性的開放取用典藏庫。
互通性是指機構典藏遵守開放典藏詮釋資料擷取協定(OAI-PMH)。如此一來便能與其他符合OAI-PMH規格的機構典藏互通，讓多個分散的機構典藏像是一個整體的虛擬機構典藏般運作，以符合搜尋的需求。符合上述特性的典藏庫不一定要是由機構或獎補助機構所維護，不過許多大學都有維護和管理典藏庫，請參考：<a href="http://www.openarchives.org/">http://www.openarchives.org/</a>
</li>
<p style="line-height:2;"></p>
<li>● 根據JISC/OSI期刊作者問卷調查結果（2004年二月, 頁56-57），當詢問研究者對於「雇主或是研究獎補助機構要求作者將其所出版之文獻副本上傳至一或多個典藏庫時的反應，大部份的作者，甚至是非開放取用期刊的論文作者都表示十分樂意。」</li>

      <p style="line-height:2;"></p>
    </ul>
    <br>
    <h3 style="font-weight:500;">當受研究獎補助者將成果投稿至開放取用期刊時，如需繳交文章處理費，請獎補助機構將開放取用的傳播納入研究成本的考量並支付該筆費用。</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>
        ● 所謂作者定稿本是指經由同儕審查後獲期刊接受的作者原稿，經常是已經過修訂的。
      </li>
      <p style="line-height:2;"></p>
      <li>
        ● 更進一步：當該研究領域有適當的開放取用期刊時，鼓勵作者將研究成果投稿至開放取用期刊。
      </li>
      <p style="line-height:2;"></p>
      <li>● 更進一步：為開放取用期刊的文章處理費預留部分的補助經費，如此作者便無須縮減研究經費來支付該筆費用。</li>
      <p style="line-height:2;"></p>
</ul>
    <br>
    <h3 style="font-weight:500;">獎助新發行的開放取用期刊，助其打穩根基，並資助為此新期刊而成立的期刊編輯委員會</h3>
    <br>
    <h3 style="font-weight:500;">提供開放取用期刊獎助金來支付作者無法負擔的文章處理費。</h3>
    <br>
    <h3 style="font-weight:500;">獎助傳統出版期刊轉型為開放取用所需的成本花費。</h3>
    <br>
    <h3 style="font-weight:500;">獎助傳統出版期刊將後台流程數位化的成本花費，以未來提供開放取用服務為交換條件。</h3>
    <br>
    <h3 style="font-weight:500;">用您的獎助金來做為建立開放取用期刊和典藏庫的基金，未來便毋須再從其他管道尋求資金。</h3>
    <br>
    <h3 style="font-weight:500;">請研究人員申請獎助金將其現有已出版、經同儕審查的期刊文獻上傳至開放取用的典藏庫，並維護一份標準化的線上個人履歷，提供文獻的開放取用版本。更多細節請見Stevan Harnad、Les Carr、Tim Brody和Charles Oppenheim於2003年發表的文章：<a href="http://www.ariadne.ac.uk/issue35/harnad/">http://www.ariadne.ac.uk/issue35/harnad/</a></h3>

  </div>
</template>
<script>
export default {
  name: 'Initiativer',
  data () {

  }
}

</script>
<style>
/*@font-face {
  font-family: Times New Roman;
  src: url(DroidSans.woff);
  unicode-range: U+000-5FF, U+1e00-1fff, U+2000-2300;
}*/

.initiativer {
  padding: 4%;
  padding-top: 2%;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom: 50px;

}

.txt {

  font-size: 20px;
  text-align: left;
  text-indent: 2em;
  font-weight: 500;

}

.txt1 {

  line-height: 1.5;
  font-size: 20px;
  text-align: left;
  padding-left: 12px;
  font-weight: 500;

}

</style>
